import { ChangeDetectorRef, Component } from "@angular/core";
import { AProgessBarWizardComponent } from '../../components/common/progressbarwizard/iprogressbar.wizard.component';
import { MessageBoxHelper } from "../../components/dialogs/messagebox/messagebox.dialog";
import { TranslateFormatText } from "../../helpers/array.helpers";
import { MessageBoxButtons } from "../../models/enums/messageboxbuttons.enum";
import { MessageBoxIcon } from "../../models/enums/messageboxicon.enum";
import { MessageBoxResult } from "../../models/enums/messageboxresult.enum";
import { IntegrationService } from "../../services/integration.service";

@Component({
    selector: 'iw-upload-page',
    templateUrl: './iw.upload.page.html',
    styleUrls: ['./iw.upload.page.css']
})
export class IntegrationWizardUploadPage extends AProgessBarWizardComponent {
    ColumnDelimiters = [
        { Caption: '{CR}{LF}', Value: '{CR}{LF}' },
        { Caption: '{CR}', Value: '{CR}' },
        { Caption: '{LF}', Value: '{LF}' },
        { Caption: '@@Strichpunkt', Value: ';' },
        { Caption: '@@Doppelpunkt', Value: ':' },
        { Caption: '@@Komma', Value: ',' },
        { Caption: '@@Tab', Value: '{t}' },
        { Caption: '@@Pipe', Value: '|' }
    ];

    get CanStepForward(): boolean {
        return this.WizardState && this.WizardState.UploadedFile;
    }

    constructor(private cdRef: ChangeDetectorRef, private service: IntegrationService) {
        super();
    }

    onFileDropped(ev: any) {
        // Get the files from the event's dataTransfer object
        this.fileBrowseHandler(ev.dataTransfer.files);
    }

    fileBrowseHandler(files: any) {
        // Check if there are any files dropped
        if (files && files.length > 0) {
            const tempfile = files[0];
            // Check if the file already exists on the server
            this.service.FileExists(tempfile.name).subscribe(x => {
                if (x) {
                    // If the file exists, show a dialog asking whether to override it
                    MessageBoxHelper.ShowDialog(new TranslateFormatText('@@FileOverrideMessageBoxText'),
                        new TranslateFormatText('@@FileExistsTxt'), MessageBoxButtons.YesNo, MessageBoxIcon.Question).then(retVal => {
                            // If the user chooses 'Yes', replace the file
                            if (retVal === MessageBoxResult.Yes) {
                                // Upload the file and update the view
                                this.uploadFile(tempfile);
                            }
                        });
                } else {
                    // Upload the file and update the view
                    this.uploadFile(tempfile);
                }
            });
        }
    }


    uploadFile(selectedFile: any) {
        // Create a new FormData object for the file upload
        const uploadData = new FormData();
        // Append the selected file to the FormData object
        uploadData.append(selectedFile.name, selectedFile);

        // Call the service method to upload the file, passing the FormData object
        this.service.UploadFile(uploadData).subscribe(() => {
            if (this.WizardState) {
                if (selectedFile.name.endsWith('.csv')) {
                    this.WizardState.FileType = 0;
                    this.WizardState.FileOptions = {
                        ColumnDelimeter: ';',
                        TxtQualifier: null,
                        HasHeaders: true
                    };
                } else {
                    this.WizardState.FileType = 1;
                    this.WizardState.FileOptions = {
                        WorksheetName: null,
                        StartColumn: 1,
                        StartRow: 1,
                        HasHeaders: true
                    };
                }
                this.WizardState.UploadedFile = selectedFile;
            }
            // Trigger change detection to update the view with the new file data
            this.cdRef.detectChanges();
        });
    }
}
